import React from 'react';
import { cn, getStatusBadgeClass, getStatusLabel } from '../../lib/utils';

export const StatusBadge = ({ status, className }) => {
  return (
    <span 
      className={cn(
        "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border",
        getStatusBadgeClass(status),
        className
      )}
      data-testid={`status-badge-${status}`}
    >
      {getStatusLabel(status)}
    </span>
  );
};

export default StatusBadge;
